import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App";
import { store } from "./store";
import { queryClient } from "./api/queryClient";
import "./locales/i18n";
import "./styles/index.scss";

import { initAdTrack } from "./utils/attribution";
import { initTracking, getConfigFromUrl } from "./api/FacebookAPI";
import { url } from "@/constants/ApiEndpointConstants";
import { LoadingProvider } from "./context/LoadingContext";

// 谷歌,facebook,站点配置初始化
initTracking();
initAdTrack();
getConfigFromUrl(url);

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <LoadingProvider>
          <App />
        </LoadingProvider>
      </QueryClientProvider>
    </Provider>
  </React.StrictMode>,
);
